"use strict";

var _classCallCheck = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var idlUtils = require("../generated/utils");

var UIEventInit = require("../generated/UIEventInit");

var EventImpl = require("./Event-impl").implementation; // Until webidl2js gains support for checking for Window, this would have to do.


function isWindow(val) {
  if (typeof val !== "object") {
    return false;
  }

  var wrapper = idlUtils.wrapperForImpl(val);

  if (typeof wrapper === "object") {
    return wrapper === wrapper._globalProxy;
  } // `val` may be either impl or wrapper currently, because webidl2js currently unwraps Window objects (and their global
  // proxies) to their underlying EventTargetImpl during conversion, which is not what we want. But at the same time,
  // some internal usage call this constructor with the actual global proxy.


  return isWindow(idlUtils.implForWrapper(val));
}

var UIEventImpl = /*#__PURE__*/function (_EventImpl) {
  _inherits(UIEventImpl, _EventImpl);

  var _super = _createSuper(UIEventImpl);

  function UIEventImpl(args, privateData) {
    _classCallCheck(this, UIEventImpl);

    var eventInitDict = args[1]; // undefined check included so that we can omit the property in internal usage.

    if (eventInitDict && eventInitDict.view !== null && eventInitDict.view !== undefined) {
      if (!isWindow(eventInitDict.view)) {
        throw new TypeError("Failed to construct '".concat((this instanceof UIEventImpl ? this.constructor : void 0).name.replace(/Impl$/, ""), "': member view is not of ") + "type Window.");
      }
    }

    return _super.call(this, args, privateData);
  }

  _createClass(UIEventImpl, [{
    key: "initUIEvent",
    value: function initUIEvent(type, bubbles, cancelable, view, detail) {
      if (view !== null) {
        if (!isWindow(view)) {
          throw new TypeError("Failed to execute 'initUIEvent' on '".concat(this.constructor.name.replace(/Impl$/, ""), "': ") + "parameter 4 is not of type 'Window'.");
        }
      }

      if (this._dispatchFlag) {
        return;
      }

      this.initEvent(type, bubbles, cancelable);
      this.view = view;
      this.detail = detail;
    }
  }]);

  return UIEventImpl;
}(EventImpl);

UIEventImpl.defaultInit = UIEventInit.convert(undefined);
module.exports = {
  implementation: UIEventImpl
};